import script from "./Kefu_dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Kefu_dialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__